import { logger } from '../logging/logger';

// Safely tear down a YouTube IFrame player.
//
// NOTE(port): the YouTube IFrame API attaches a player's methods
// (removeEventListener / stopVideo / destroy / playVideo …) only AFTER the
// player fires `onReady`. A player created moments earlier — which happens
// during rapid song switching, when destroyPlayer() runs before the previous
// player finished initialising — is a bare shell, so calling removeEventListener
// on it throws "removeEventListener is not a function".
//
// The original inline teardown let that throw escape past the listener-removal
// lines, so `destroy()` and the playerRef reset that followed never ran: the
// half-built player was orphaned (it became ready and autoplayed with nothing
// controlling it) and the bottom bar was left with showControls=false, where
// every control early-returns — the reported "stuck / unclickable mini-player".
//
// Guarding each call with a typeof check mirrors updateProgress() (which already
// guards getCurrentTime) and lets teardown always reach destroy() when it
// exists. A still-initialising player can't be destroyed here (no destroy() yet)
// — onPlayerReady destroys it once it is no longer the current player.
export function safeDestroyYoutubePlayer(player: any): void {
  if (!player) {
    return;
  }
  try {
    if (typeof player.removeEventListener === 'function') {
      player.removeEventListener('onReady');
      player.removeEventListener('onStateChange');
      player.removeEventListener('onError');
    }
    if (typeof player.stopVideo === 'function') {
      player.stopVideo();
    }
    if (typeof player.destroy === 'function') {
      player.destroy();
    }
  } catch (error) {
    logger.error('playback', 'error destroying youtube player', {
      message: (error as Error)?.message,
    });
  }
}
